<template>
	<ul class="nav">
		<li class="nav-profile">
			<a href="javascript:;" v-on:click="expand()">
				<div class="cover with-shadow"></div>
				<div class="image">
					<img :src="URL_WEB()+this.$store.state.usuario.foto" alt="" width="54px" height="54px">
				</div>
				<div class="info">
					
					{{this.$store.state.usuario.nombres | mayuscula}}
					<small>{{this.$store.state.usuario.tipo }}</small>
				</div>
			</a>
		</li>
		
	</ul>
</template>

<script>
import PageOptions from '../../config/PageOptions.vue'

export default {
	name: 'SidebarNavProfile',
	data() {
		return {
			stat: '',
			pageOptions: PageOptions
		}
	},
	methods: {
		expand: function() {
			this.stat = (this.stat == 'expand') ? 'collapse' : 'expand'
		}
  }
}
</script>
